import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Define the initial state using that type
const initialState: any = {
  stopsStore: [],
  selectedStop: null,
};

export const stopsSlices = createSlice({
  name: 'stopsSlices',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateStops: (state, action) => {
      state.stopsStore = action.payload;
    },
    updateStop: (state, action) => {
      state.stopsStore = state.stopsStore.map((stop) => {
        return stop.id === action.payload.id
          ? {
              ...stop,
              ...action.payload,
            }
          : stop;
      });
    },
    updateSelectedStop: (state, action) => {
      state.selectedStop = action.payload;
    },
  },
});

export const { updateStops, updateStop, updateSelectedStop } = stopsSlices.actions;

// Other code such as selectors can use the imported `RootState` type
export const stopsState = (state: RootState) => state.stops.stopsStore;
export const selectedStopState = (state: RootState) => state.stops.selectedStop;

export default stopsSlices.reducer;
